// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Services/UserBusinessLocationService.proto (syntax proto3)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../google/api/annotations_pb";
import { file_Enumerations_AuthorizationPolicy } from "../Enumerations/AuthorizationPolicy_pb";
import type { IdentityUserBusinessLocationModificationDtoSchema } from "../Messages/Basic_pb";
import { file_Messages_Basic } from "../Messages/Basic_pb";
import type { IdentityUserDetailedDtoSchema } from "../Messages/Detailed_pb";
import { file_Messages_Detailed } from "../Messages/Detailed_pb";
import { file_Options_MethodOptions } from "../Options/MethodOptions_pb";

/**
 * Describes the file Services/UserBusinessLocationService.proto.
 */
export const file_Services_UserBusinessLocationService: GenFile = /*@__PURE__*/
  fileDesc("CipTZXJ2aWNlcy9Vc2VyQnVzaW5lc3NMb2NhdGlvblNlcnZpY2UucHJvdG8ysAYKG1VzZXJCdXNpbmVzc0xvY2F0aW9uU2VydmljZRL/AgoZQWRkVXNlclRvQnVzaW5lc3NMb2NhdGlvbhJJLnRpbWVfdHJhY2tpbmcubWVzc2FnZXMuYmFzaWMuSWRlbnRpdHlVc2VyQnVzaW5lc3NMb2NhdGlvbk1vZGlmaWNhdGlvbkR0bxo4LnRpbWVfdHJhY2tpbmcubWVzc2FnZXMuZGV0YWlsZWQuSWRlbnRpdHlVc2VyRGV0YWlsZWREdG8i3AGg2s0PAILT5JMC0AFaODoBKiIzL2FwaS91c2VyQnVzaW5lc3NMb2NhdGlvbi9hZGRVc2VyVG9CdXNpbmVzc0xvY2F0aW9uGpMBL2FwaS91c2VyQnVzaW5lc3NMb2NhdGlvbi9hZGRVc2VyVG9CdXNpbmVzc0xvY2F0aW9uL3t1c2VyX2lkLmhpZ2hfNjR9L3t1c2VyX2lkLmxvd182NH0ve2J1c2luZXNzX2xvY2F0aW9uX2lkLmhpZ2hfNjR9L3tidXNpbmVzc19sb2NhdGlvbl9pZC5sb3dfNjR9Eo4DCh5SZW1vdmVVc2VyRnJvbUJ1c2luZXNzTG9jYXRpb24SSS50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmJhc2ljLklkZW50aXR5VXNlckJ1c2luZXNzTG9jYXRpb25Nb2RpZmljYXRpb25EdG8aOC50aW1lX3RyYWNraW5nLm1lc3NhZ2VzLmRldGFpbGVkLklkZW50aXR5VXNlckRldGFpbGVkRHRvIuYBoNrNDwCC0+STAtoBWj06ASoiOC9hcGkvdXNlckJ1c2luZXNzTG9jYXRpb24vcmVtb3ZlVXNlckZyb21CdXNpbmVzc0xvY2F0aW9uKpgBL2FwaS91c2VyQnVzaW5lc3NMb2NhdGlvbi9yZW1vdmVVc2VyRnJvbUJ1c2luZXNzTG9jYXRpb24ve3VzZXJfaWQuaGlnaF82NH0ve3VzZXJfaWQubG93XzY0fS97YnVzaW5lc3NfbG9jYXRpb25faWQuaGlnaF82NH0ve2J1c2luZXNzX2xvY2F0aW9uX2lkLmxvd182NH1CJKoCIU1vZ2kuVGltZVRyYWNraW5nLkNvbW1vbi5TZXJ2aWNlc2IGcHJvdG8z", [file_google_api_annotations, file_Enumerations_AuthorizationPolicy, file_Messages_Basic, file_Messages_Detailed, file_Options_MethodOptions]);

/**
 * Operations for mapping Identity users to business locations.
 *
 * @generated from service UserBusinessLocationService
 */
export const UserBusinessLocationService: GenService<{
  /**
   * Add the user with the contained id to the business location with the contained id.
   *
   * @generated from rpc UserBusinessLocationService.AddUserToBusinessLocation
   */
  addUserToBusinessLocation: {
    methodKind: "unary";
    input: typeof IdentityUserBusinessLocationModificationDtoSchema;
    output: typeof IdentityUserDetailedDtoSchema;
  },
  /**
   * Remove the user with the contained id from the business location with the contained id.
   *
   * @generated from rpc UserBusinessLocationService.RemoveUserFromBusinessLocation
   */
  removeUserFromBusinessLocation: {
    methodKind: "unary";
    input: typeof IdentityUserBusinessLocationModificationDtoSchema;
    output: typeof IdentityUserDetailedDtoSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_Services_UserBusinessLocationService, 0);

